import React from 'react';

import { useFormContext } from 'src/components/custom-form/FormContext';
import InvalidLinkPage from 'src/components/UI/addons/InvalidLinkPage';
import SubmissionConfirmation from 'src/components/questionnaire/confirm-details/SubmissionConfirmation';
import UserCustomForm from './UserCustomForm';
import { CONSTANTS } from './Constants';

export default function CustomFormContainer() {
  const {
    status,
    form,
    isInvalidLink,
    isDeactivatedLink,
    submissionReference,
    submittedAt
  } = useFormContext();

  // A deactivated or otherwise-invalid link both surface the same generic
  // "no longer valid" page (this component renders inside CustomForm's shell,
  // so the branded header is already present).
  if (isDeactivatedLink || isInvalidLink) {
    return <InvalidLinkPage />;
  }

  if (status === CONSTANTS.user_status.SUBMITTED)
    return (
      <SubmissionConfirmation
        noun="form"
        reference={submissionReference}
        submittedAt={submittedAt}
      />
    );

  if (form) return <UserCustomForm />;

  return null;
}
